var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('router-link',{staticClass:"mr-3 btn btn-info",attrs:{"to":{
      path: ("/Group/product-stock/details/" + (_vm.data.productID) + "/" + (_vm.data.productName)),
      query: Object.assign({}, {groupId: _vm.$route.query.groupId}, _vm.$route.query),
    }}},[_vm._v("\n  "+_vm._s(_vm.$t('text.clickButtons.details'))+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"mr-3 btn btn-primary",attrs:{"to":{
      name: 'GroupSupplyHistory',
      query: Object.assign({}, {productId: _vm.data.productID,
        productName: _vm.data.productName,
        groupId: _vm.$route.query.groupId},
        _vm.$route.query),
    }}},[_vm._v("\n  "+_vm._s(_vm.$t('text.clickButtons.supplyHistory'))+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":{
      name: 'GroupSalesHistory',
      query: Object.assign({}, {productId: _vm.data.productID,
        productName: _vm.data.productName,
        groupId: _vm.$route.query.groupId},
        _vm.$route.query),
    }}},[_vm._v("\n  "+_vm._s(_vm.$t('text.clickButtons.salesHistory'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }